var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damageMobilier-category3 view" }, [
    _c(
      "div",
      { staticClass: "view_top" },
      [
        _c("maNotificationsTop", {
          attrs: { errorMsgGeneral: _vm.errorMsg, errorIsVisible: _vm.error },
        }),
        _c("ma-navbar-category-specific", {
          attrs: {
            titleNavbar: _vm.titleCategory,
            handleClickBackArrow: _vm.handleClickPrevPage,
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "view_content" }, [
      _vm.formType === "formInputsMobilier"
        ? _c(
            "div",
            { staticClass: "container-form" },
            [
              _c("div", { staticClass: "view_content_markdown" }, [
                _c("h1", [_vm._v(_vm._s(_vm.titleCategory))]),
                _c("p", [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
                ]),
              ]),
              _c("ma-form", {
                key: _vm.formKey,
                staticClass: "mg-mg-t",
                attrs: {
                  type: "large",
                  formData: _vm.formData.form,
                  titleFileInputPres: _vm.$t(
                    "damageDetails.titleFileInputPres"
                  ),
                  nameFileInputPres: "inputImgPres",
                  inputImgListPres: _vm.imgListPres,
                },
                on: {
                  change: function ($event) {
                    _vm.handleFormChange($event)
                    _vm.handleNestedComponents($event)
                  },
                  "file:change-pres": _vm.handleImgChangePres,
                },
                nativeOn: {
                  focus: function ($event) {
                    return _vm.handleInputFocus()
                  },
                },
              }),
            ],
            1
          )
        : _vm.formType === "uptecFeature"
        ? _c(
            "div",
            { staticClass: "container-form_feature" },
            [
              _c("div", { staticClass: "containerImgProduct mg mg--t-8" }, [
                _c("img", {
                  attrs: { src: _vm.stateWarrantyObjUptec.imageFeature },
                }),
              ]),
              _c(
                "p",
                { staticClass: "gray headline-large mg mg--t-8 mg--b-1" },
                [_vm._v(_vm._s(_vm.titleCategory))]
              ),
              _c("p", { staticClass: "gray text-medium-large mg mg--b-1" }, [
                _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
              ]),
              _c("p", { staticClass: "gray text-medium-large mg mg--b-5" }, [
                _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
              ]),
              _c("ma-date-picker", {
                attrs: {
                  errorInput: _vm.errorDate,
                  handleChangeInput: _vm.handleChangeInputDate,
                  literal: _vm.$t("datePicker.literal"),
                },
              }),
              _c("ma-input-file", {
                staticClass: "mg mg--b-22",
                attrs: {
                  titleInput: _vm.$t("damageDetails.titleFileInputPres"),
                  name: "inputImgPres",
                  imageList: _vm.imgListPres,
                },
                on: { "file:src": _vm.handleImgChangePres },
              }),
              _c(
                "ma-modal",
                {
                  ref: "modalConfirmationFeature",
                  staticClass: "modal-confirmation",
                  attrs: { type: "small" },
                  on: { "modal:close": _vm.closeModaConfirmationFeature },
                },
                [
                  _c("template", { slot: "modalContent" }, [
                    _c(
                      "div",
                      { staticClass: "modal__main" },
                      [
                        _c(
                          "p",
                          { staticClass: "gray headline-large mg mg--b-3" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.modal1"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "gray text-medium-large mg mg--b-10" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.modal2"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-small-bold black mg mg--b-1" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.date"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-small-bold black mg mg--b-10" },
                          [_vm._v(_vm._s(_vm.inputValDate))]
                        ),
                        _c("ma-add-damages", {
                          staticClass: "buttonsNextActions",
                          attrs: {
                            handleButtonClick: _vm.handleAddDamagesFeatureUptec,
                            handleButtonClickWhiteBtn:
                              _vm.closeModaConfirmationFeature,
                            title: _vm.$t(
                              "damageMobilier.category.buttonsNextActionsTitle"
                            ),
                            titleWhiteBtn: _vm.$t(
                              "damageMobilier.category.buttonsNextActionsTitleWhiteBtn"
                            ),
                            btnType: "functionalBtnWhite",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm.formType === "uptecCpi"
        ? _c(
            "div",
            { staticClass: "container-form_cpi" },
            [
              _c(
                "p",
                { staticClass: "gray headline-large mg mg--t-4 mg--b-1" },
                [_vm._v(_vm._s(_vm.titleCategory))]
              ),
              _c("p", { staticClass: "gray text-medium-large mg mg--b-1" }, [
                _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
              ]),
              _c("p", { staticClass: "gray text-medium-large mg mg--b-3" }, [
                _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
              ]),
              _c("ma-date-picker", {
                attrs: {
                  errorInput: _vm.errorDate,
                  handleChangeInput: _vm.handleChangeInputDate,
                  literal: _vm.$t("datePicker.literal"),
                },
              }),
              _c("ma-input-txt", {
                staticClass: "mg mg--b-5",
                attrs: {
                  type: "text",
                  required: "",
                  name: "inputPrice",
                  col: "4",
                  icon: "",
                  literal: _vm.$t("damageMobilier.category.price"),
                  inputError: _vm.errorPrice,
                  inputTextError: _vm.$t(
                    "damageMobilier.category.inputTextError"
                  ),
                },
                model: {
                  value: _vm.inputValPrice,
                  callback: function ($$v) {
                    _vm.inputValPrice = $$v
                  },
                  expression: "inputValPrice",
                },
              }),
              _c("ma-input-file", {
                attrs: {
                  titleInput: _vm.$t("damageDetails.titleFileInputPres"),
                  name: "inputImgPres",
                  imageList: _vm.imgListPres,
                },
                on: { "file:src": _vm.handleImgChangePres },
              }),
              _c(
                "ma-modal",
                {
                  ref: "modalConfirmation",
                  staticClass: "modal-confirmation",
                  attrs: { type: "small" },
                  on: { "modal:close": _vm.closeModaConfirmation },
                },
                [
                  _c("template", { slot: "modalContent" }, [
                    _c(
                      "div",
                      { staticClass: "modal__main" },
                      [
                        _c(
                          "p",
                          { staticClass: "gray headline-large mg mg--b-3" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.modal1"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "gray text-medium-large mg mg--b-5" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.modal2"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-small-bold black mg mg--b-1" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.date"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-small-bold black mg mg--b-5" },
                          [_vm._v(_vm._s(_vm.inputValDate))]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-small-bold black mg mg--b-1" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damageMobilier.category.price"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-small-bold black mg mg--b-5" },
                          [_vm._v(_vm._s(_vm.inputValPrice))]
                        ),
                        _c("ma-add-damages", {
                          staticClass: "buttonsNextActions",
                          attrs: {
                            handleButtonClick: _vm.handleAddDamagesCpi,
                            handleButtonClickWhiteBtn:
                              _vm.closeModaConfirmation,
                            title: _vm.$t(
                              "damageMobilier.category.buttonsNextActionsTitle"
                            ),
                            titleWhiteBtn: _vm.$t(
                              "damageMobilier.category.buttonsNextActionsTitleWhiteBtn"
                            ),
                            btnType: "functionalBtnWhite",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _vm.formType === "formInputsMobilier"
          ? _c("ma-add-damages", {
              attrs: {
                handleButtonClick: _vm.handleAddDamages,
                title: _vm.$t("addDamages.buttonTitle"),
                btnType: _vm.getBtnType,
                "qa-confirmSinisterInfo-button": "",
              },
            })
          : _vm.formType === "uptecFeature"
          ? _c("ma-add-damages", {
              attrs: {
                handleButtonClick: _vm.handleOpenModalFeature,
                title: _vm.$t("addDamages.buttonTitleFeature"),
                shouldBeDisabled: !_vm.inputValDate,
                btnType: _vm.getBtnType,
              },
            })
          : _vm.formType === "uptecCpi"
          ? _c("ma-add-damages", {
              attrs: {
                handleButtonClick: _vm.handleOpenModal,
                title: _vm.$t("addDamages.buttonTitle"),
                shouldBeDisabled: !_vm.inputValPrice || !_vm.inputValDate,
                btnType: _vm.getBtnType,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }